import { connect } from "react-redux";
import AttendanceRequestList from "./AttendanceRequestList";
import { bindActionCreators } from "redux";
import { fetchAttendanceRequests , valetAttendanceRequest , allValetUsers} from "services/redux/Valet/Supervisor/action";
const mapStateToProps = (state) => ({
    getAttendanceRequests: state.CreateSupervisor.getAttendanceRequests,
    valetAttendanceRequest: state.CreateSupervisor.valetAttendanceRequest,
    allValetUsers: state.CreateSupervisor.allValetUsers
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        fetchAttendanceRequests,
        valetAttendanceRequest,
        allValetUsers
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AttendanceRequestList);
